export const configDocuments = [
  { id: 'documentName', header: 'Nombre' },
  { id: 'documentCompany', header: 'Empresa' },
  { id: 'processStartDate', header: 'Fecha' },
  { id: 'signingProcessStatusId', header: 'Estado' },
  { id: 'actions', header: '' }
]
